export default __webpack_public_path__ + "static/media/sarchu1.78d162b3.jpg";